// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1X8zG","row":"ProcedureTreatmentSummary_row__2WhMx"};